import Super from 'client-portal/routes/-request/prescreener-administrative';

export default class SiteRequestPrescreenerAdministrative extends Super {}
